// extracted by mini-css-extract-plugin
module.exports = {"loader-row":"loader-row__2tBie","loader":"loader__14Z6b"};